import { defineModule } from '../../utils/helpers';
import { toggleModal, type ModalId } from '.';

export const HASH_TO_MODAL_ID_MAP: Record<string, ModalId> = {
  wachtlijst: 'waitlist',
};

const onElementClick = (e: Event) => {
  if (!(e.target instanceof HTMLAnchorElement)) return;

  const url = new URL(e.target.href);

  const modalId = HASH_TO_MODAL_ID_MAP[url.hash.substring(1)];
  if (!modalId) return;

  e.preventDefault();
  toggleModal(modalId, true);
};

export default defineModule(
  () => {
    document.addEventListener('click', onElementClick);
  },
  () => {
    document.removeEventListener('click', onElementClick);
  },
);
